import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { useData } from '../../contexts/DataContext';
import { GRUPOS_MUSCULARES } from '../../lib/gruposMusculares';

const GRUPOS = GRUPOS_MUSCULARES;

function ExForm({ inicial, onSalvar, onCancelar }) {
  const [form, setForm] = useState({
    nome: inicial?.nome || '',
    grupoMuscular: inicial?.grupoMuscular || '',
    videoUrl: inicial?.videoUrl || '',
    instrucoes: inicial?.instrucoes || '',
  });
  return (
    <div style={{ background:'var(--surface-2)', border:'1px solid var(--divider)', borderRadius:'20px', padding:'20px', marginBottom:'12px' }}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px', marginBottom:'12px' }}>
        <div>
          <label style={s.lbl}>Nome do exercício *</label>
          <input style={s.input} value={form.nome} onChange={e=>setForm(f=>({...f,nome:e.target.value}))} placeholder="Ex: Supino Reto" />
        </div>
        <div>
          <label style={s.lbl}>Grupo muscular</label>
          <select style={s.input} value={form.grupoMuscular} onChange={e=>setForm(f=>({...f,grupoMuscular:e.target.value}))}>
            <option value="">Selecionar...</option>
            {GRUPOS.map(g => <option key={g} value={g}>{g}</option>)}
          </select>
        </div>
      </div>
      <div style={{ marginBottom:'12px' }}>
        <label style={s.lbl}>Link do vídeo (YouTube)</label>
        <input style={s.input} value={form.videoUrl} onChange={e=>setForm(f=>({...f,videoUrl:e.target.value}))} placeholder="https://youtube.com/watch?v=..." />
      </div>
      <div style={{ marginBottom:'16px' }}>
        <label style={s.lbl}>Instruções de execução</label>
        <textarea style={{ ...s.input, height:'72px', resize:'none' }} value={form.instrucoes} onChange={e=>setForm(f=>({...f,instrucoes:e.target.value}))} placeholder="Dicas de execução para a aluna..." />
      </div>
      <div style={{ display:'flex', gap:'8px' }}>
        <button onClick={() => form.nome && onSalvar(form)} style={{ ...s.btnPrimary, opacity: form.nome ? 1 : 0.5 }}>Salvar exercício</button>
        <button onClick={onCancelar} style={s.btnSecondary}>Cancelar</button>
      </div>
    </div>
  );
}

export default function BibliotecaExercicios() {
  const { exerciciosBiblioteca, salvarExercicioBiblioteca, deletarExercicioBiblioteca } = useData();
  const [busca, setBusca] = useState('');
  const [grupo, setGrupo] = useState('');
  const [criando, setCriando] = useState(false);
  const [editando, setEditando] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  const filtrados = exerciciosBiblioteca.filter(ex => {
    const matchBusca = ex.nome.toLowerCase().includes(busca.toLowerCase());
    const matchGrupo = !grupo || ex.grupoMuscular === grupo;
    return matchBusca && matchGrupo;
  });

  async function handleSalvar(form) {
    await salvarExercicioBiblioteca({ ...form, id: editando?.id });
    setCriando(false);
    setEditando(null);
  }

  return (
    <AdminLayout>
      <style>{`
        .ex-card { background:var(--surface); border:1px solid var(--divider); border-radius:20px; padding:16px; margin-bottom:8px; display:flex; align-items:flex-start; gap:14px; transition:box-shadow 0.2s; }
        .ex-card:hover { box-shadow:var(--sh-card); }
        .grupo-badge { display:inline-block; padding:2px 8px; background:rgba(137,91,64,0.1); color:var(--accent); border-radius:100px; font-size:10px; font-weight:700; letter-spacing:0.06em; text-transform:uppercase; }
      `}</style>

      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'28px', flexWrap:'wrap', gap:'12px' }}>
        <div>
          <h1 style={s.title}>Biblioteca de <em style={s.em}>Exercícios</em></h1>
          <p style={s.sub}>{exerciciosBiblioteca.length} exercício{exerciciosBiblioteca.length !== 1 ? 's' : ''} cadastrado{exerciciosBiblioteca.length !== 1 ? 's' : ''}</p>
        </div>
        {!criando && <button onClick={() => setCriando(true)} style={s.btnPrimary}>+ Novo exercício</button>}
      </div>

      {criando && <ExForm onSalvar={handleSalvar} onCancelar={() => setCriando(false)} />}

      {/* Filtros */}
      <div style={{ display:'flex', gap:'10px', marginBottom:'20px', flexWrap:'wrap' }}>
        <input style={{ ...s.input, flex:1, minWidth:'180px', marginBottom:0 }} placeholder="Buscar exercício..." value={busca} onChange={e=>setBusca(e.target.value)} />
        <select style={{ ...s.input, width:'160px', marginBottom:0 }} value={grupo} onChange={e=>setGrupo(e.target.value)}>
          <option value="">Todos os grupos</option>
          {GRUPOS.map(g => <option key={g} value={g}>{g}</option>)}
        </select>
      </div>

      {filtrados.length === 0 ? (
        <div style={{ padding:'40px 20px', textAlign:'center', color:'var(--text-2)', fontSize:'13px', background:'var(--surface)', border:'1px solid var(--divider)', borderRadius:'20px', lineHeight:1.7 }}>
          {busca || grupo ? 'Nenhum exercício encontrado com esses filtros.' : 'Nenhum exercício cadastrado ainda.\nClique em "+ Novo exercício" para começar.'}
        </div>
      ) : (
        filtrados.map(ex => (
          editando?.id === ex.id ? (
            <ExForm key={ex.id} inicial={editando} onSalvar={handleSalvar} onCancelar={() => setEditando(null)} />
          ) : (
            <div key={ex.id} className="ex-card">
              <div style={{ flex:1 }}>
                <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px' }}>
                  <div style={{ fontSize:'14px', fontWeight:600, color:'var(--text)' }}>{ex.nome}</div>
                  {ex.grupoMuscular && <span className="grupo-badge">{ex.grupoMuscular}</span>}
                </div>
                {ex.instrucoes && <div style={{ fontSize:'12px', color:'var(--text-2)', lineHeight:1.6, marginBottom:'4px' }}>{ex.instrucoes}</div>}
                {ex.videoUrl && (
                  <a href={ex.videoUrl} target="_blank" rel="noreferrer" style={{ fontSize:'11px', color:'var(--accent)', fontWeight:600, display:'inline-flex', alignItems:'center', gap:'4px' }}>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
                    Ver vídeo
                  </a>
                )}
              </div>
              <div style={{ display:'flex', gap:'6px', flexShrink:0 }}>
                <button onClick={() => setEditando(ex)} style={{ padding:'5px 10px', background:'transparent', border:'1px solid rgba(137,91,64,0.3)', color:'var(--accent)', borderRadius:'var(--r-btn)', fontSize:'11px', fontWeight:600, cursor:'pointer' }}>Editar</button>
                {confirmDelete === ex.id ? (
                  <div style={{ display:'flex', gap:'4px' }}>
                    <button onClick={async () => { await deletarExercicioBiblioteca(ex.id); setConfirmDelete(null); }} style={{ padding:'5px 10px', background:'#C62828', color:'#fff', border:'none', borderRadius:'var(--r-btn)', fontSize:'11px', fontWeight:600, cursor:'pointer' }}>Confirmar</button>
                    <button onClick={() => setConfirmDelete(null)} style={{ padding:'5px 10px', background:'transparent', border:'1px solid var(--divider)', color:'var(--text-2)', borderRadius:'var(--r-btn)', fontSize:'11px', cursor:'pointer' }}>Não</button>
                  </div>
                ) : (
                  <button onClick={() => setConfirmDelete(ex.id)} style={{ padding:'5px 10px', background:'transparent', border:'1px solid rgba(229,57,53,0.3)', color:'#C62828', borderRadius:'var(--r-btn)', fontSize:'11px', fontWeight:600, cursor:'pointer' }}>Excluir</button>
                )}
              </div>
            </div>
          )
        ))
      )}
    </AdminLayout>
  );
}

const s = {
  title: { fontFamily:"'Inter', sans-serif", fontSize:'34px', fontWeight:700, color:'var(--text)', margin:0 },
  em: { fontStyle:'italic', color:'var(--accent)' },
  sub: { fontSize:'13px', color:'var(--text-2)', marginTop:'4px' },
  lbl: { display:'block', fontSize:'10px', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:'var(--text-2)', marginBottom:'4px' },
  input: { width:'100%', padding:'9px 12px', border:'1.5px solid var(--divider)', borderRadius:'var(--r-input)', fontSize:'13px', color:'var(--text)', background:'var(--surface)', outline:'none', fontFamily:"'Inter',sans-serif", boxSizing:'border-box', marginBottom:'0' },
  btnPrimary: { padding:'10px 20px', background:'var(--accent)', color:'var(--btn-text)', border:'none', borderRadius:'var(--r-btn)', fontSize:'12px', fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase', cursor:'pointer', fontFamily:"'Inter',sans-serif" },
  btnSecondary: { padding:'10px 20px', background:'transparent', border:'1.5px solid var(--divider)', color:'var(--text)', borderRadius:'var(--r-btn)', fontSize:'12px', fontWeight:600, cursor:'pointer', fontFamily:"'Inter',sans-serif" },
};
